import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import {
  themes,
  tableRowSx,
  scrollTop,
  optionalAvathar,
  adminRoleName,
} from "services/constants";
import { Loader } from "components/Loader";
import { useSelector } from "react-redux";
import { getContrastingTextColor } from "services/utils/colorChecker";
import { getColorWorkingHours } from "services/utils/Status";
import { showToast } from "services/utils/Status";
import { EditCheckInOut } from "../AttendanceStatus/Status/EditCheckInOut";
import { tooltipStyleProps } from "services/constants/Styles";

export const AttendanceTimeLine = ({
  leavePage,
  setLeavePage,
  attendanceDetails,
  attendanceDataDetails,
  loading,
  reCallPayScheduleApi,
}) => {
  const { userDetails: currentUserDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  let access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Attendance",
    "Time Line"
  );
  const [departmentId, setDepartmentId] = useState(99999);
  const [leaverowsPerPage, setLeaveRowsPerPage] = useState(25);
  const [shiftDetails, setShiftDetails] = useState({});
  const [openSidePeek, setOpenSidePeek] = useState(false);
  const [editState, setEditState] = useState(false);
  const containerRef = useRef(null);

  const handleChangeLeavePage = (event, newPage) => {
    setLeavePage(newPage);
  };

  const handleChangeLeaveRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  useEffect(() => {
    const recallApi = () => {
      setEditState(false);
      reCallPayScheduleApi(true);
    };
    if (editState && !openSidePeek) {
      recallApi();
    }
  });

  const attendanceTypes = [
    { label: "Present", code: "P" },
    { label: "Permission", code: "PR" },
    { label: "Half day", code: "HL" },
    { label: "Holiday", code: "H" },
    { label: "Leave", code: "L" },
    { label: "Absent", code: "A" },
    { label: "Missing", code: "M" },
    { label: "Week off", code: "W", border: true },
    { label: "Unassigned", code: "UA" },
    { label: "Shift Planned", code: "SP" },
    { label: "Not Joined", code: "NJ" },
  ];

  useEffect(() => {
    scrollTop(containerRef);
  }, [leavePage]);

  return (
    <React.Fragment>
      {loading ? (
        <Loader info="Loading..." />
      ) : (
        <Mui.Grid container>
          <Mui.TableContainer
            ref={containerRef}
            sx={{ mt: 2, width: "100%", maxHeight: 660, ml: 2, mr: 2 }}
          >
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow sx={tableRowSx}>
                  <Mui.TableCell
                    sx={{
                      color: themes.headLine,
                      fontWeight: "bold",
                    }}
                  >
                    Name
                  </Mui.TableCell>
                  <Mui.TableCell
                    sx={{
                      color: themes.headLine,
                      fontWeight: "bold",
                    }}
                  >
                    Department
                  </Mui.TableCell>
                  {attendanceDetails?.headers?.map((header) => (
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      <Mui.Stack>
                        <Mui.Typography
                          textAlign="center"
                          sx={{
                            color: themes.headLine,
                            fontWeight: "bold",
                            fontSize: 10,
                          }}
                        >
                          {header.day_number}
                        </Mui.Typography>
                        <Mui.Typography
                          textAlign="center"
                          sx={{
                            olor: themes.headLine,
                            fontWeight: "bold",
                            fontSize: 10,
                          }}
                        >
                          {header.day}
                        </Mui.Typography>
                      </Mui.Stack>
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {attendanceDataDetails?.length === 0 && !loading ? (
                  <Mui.TableRow sx={{ height: "750px" }}>
                    <Mui.TableCell
                      colSpan={attendanceDetails?.headers?.length + 6}
                      sx={{
                        padding: 2,
                        position: "absolute",
                        width: "97%",
                      }}
                    >
                      <Mui.Alert severity="info">
                        {attendanceDetails?.attendance_data?.length === 0
                          ? "No data available."
                          : "No matching data found for your search."}
                      </Mui.Alert>
                    </Mui.TableCell>
                  </Mui.TableRow>
                ) : (
                  attendanceDataDetails
                    ?.slice(
                      leavePage * leaverowsPerPage,
                      leavePage * leaverowsPerPage + leaverowsPerPage
                    )
                    .map((attendancedata) => (
                      <Mui.TableRow
                        key={attendancedata.user_id}
                        sx={tableRowSx}
                      >
                        <Mui.TableCell className="column-cell">
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={attendancedata?.user}
                          >
                            <Mui.Stack direction="Row">
                              <Mui.Avatar
                                sx={{ width: 23, height: 23 }}
                                alt={attendancedata?.user
                                  ?.charAt(0)
                                  .toUpperCase()}
                                src={
                                  attendancedata?.image_url ?? optionalAvathar
                                }
                              />
                              <Mui.Typography
                                noWrap
                                sx={{ cursor: "pointer", paddingLeft: 1 }}
                              >
                                {attendancedata?.user?.length > 15
                                  ? attendancedata?.user.slice(0, 15) + "..."
                                  : attendancedata?.user}
                              </Mui.Typography>
                            </Mui.Stack>
                          </Mui.Tooltip>
                        </Mui.TableCell>
                        <Mui.TableCell className="column-cell">
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={attendancedata?.department}
                          >
                            <Mui.Typography
                              noWrap
                              sx={{ cursor: "pointer", paddingLeft: 0.3 }}
                            >
                              {attendancedata?.department?.length > 15
                                ? attendancedata?.department.slice(0, 15) +
                                  "..."
                                : attendancedata?.department}
                            </Mui.Typography>
                          </Mui.Tooltip>
                        </Mui.TableCell>
                        {attendancedata?.attendance?.map((dayDetails) => (
                          <Mui.TableCell
                            align="center"
                            onClick={() => {
                              if (access && dayDetails?.legend) {
                                if (
                                  (dayDetails.legend !== "UA" &&
                                    attendancedata?.user_id !==
                                      currentUserDetails?.id) ||
                                  (currentUserDetails?.type === adminRoleName &&
                                    dayDetails.legend !== "UA")
                                ) {
                                  setDepartmentId(
                                    attendancedata?.department_id
                                  );
                                  setShiftDetails({
                                    user_id: attendancedata?.user_id,
                                    shift_filter_date: dayDetails?.date,
                                    date: dayDetails?.date
                                      .split("-")
                                      .reverse()
                                      .join("-"),
                                    user_name: attendancedata?.user,
                                    shift_name: dayDetails?.shift_name,
                                    latest_pay_date:
                                      attendancedata?.latest_pay_date,
                                    type: dayDetails?.status,
                                    image_url: attendancedata?.image_url,
                                    employee_id: attendancedata?.employee_id,
                                    department_name: attendancedata?.department,
                                    user_type: attendancedata?.user_type,
                                  });
                                  setOpenSidePeek(true);
                                } else {
                                  if (
                                    attendancedata?.user_id ===
                                    currentUserDetails?.id
                                  ) {
                                    showToast(
                                      "error",
                                      "Your data cannot be edited by yourself"
                                    );
                                  } else if (dayDetails?.legend === "UA") {
                                    showToast(
                                      "error",
                                      "Unassigned shifts cannot be edited"
                                    );
                                  }
                                }
                              } else if (dayDetails?.legend) {
                                showToast(
                                  "error",
                                  "Access denied: You are not authorized to modify this data"
                                );
                              }
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                width: "25px",
                                height: "20px",
                                backgroundColor: dayDetails.colour_code,
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <Mui.Typography
                                sx={{
                                  fontSize: 15,
                                  color: getContrastingTextColor(
                                    dayDetails?.colour_code
                                      ? dayDetails?.colour_code
                                      : "#FFFFF"
                                  ),
                                }}
                              >
                                {dayDetails.legend}
                              </Mui.Typography>
                            </div>
                          </Mui.TableCell>
                        ))}
                      </Mui.TableRow>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
        </Mui.Grid>
      )}
      <Mui.Grid container spacing={2} alignItems="center">
        <Mui.Grid item xs={12} sm={12} md={6}></Mui.Grid>
        <Mui.Grid item xs={12} sm={12} md={6} sx={{ textAlign: "center" }}>
          {attendanceDataDetails?.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              rowsPerPageOptions={[25, 50, 75, 100]}
              component="div"
              count={attendanceDataDetails?.length}
              rowsPerPage={leaverowsPerPage}
              page={leavePage}
              onPageChange={handleChangeLeavePage}
              onRowsPerPageChange={handleChangeLeaveRowsPerPage}
            />
          )}
        </Mui.Grid>
        <Mui.Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            marginTop: attendanceDataDetails?.length > 25 ? -2 : 0,
            ml: 2,
            mr: 2,
          }}
        >
          <Mui.Paper
            elevation={3}
            sx={{
              padding: 2,
              borderRadius: 2,
              backgroundColor: "transparent",
            }}
          >
            <Mui.Grid container spacing={2}>
              {attendanceTypes.map(({ label, code, border }) => (
                <Mui.Grid item xs={12} sm={6} md={3} lg={2} key={code}>
                  <Mui.Stack direction="row" alignItems="center">
                    <Mui.Box
                      sx={{
                        width: 30,
                        height: 20,
                        backgroundColor: getColorWorkingHours(code),
                        border: border ? "1px solid black" : "none",
                        borderRadius: 1,
                        cursor: "pointer",
                      }}
                    />
                    <Mui.Typography variant="body2" sx={{ ml: 1 }}>
                      {label}
                    </Mui.Typography>
                  </Mui.Stack>
                </Mui.Grid>
              ))}
            </Mui.Grid>
          </Mui.Paper>
        </Mui.Grid>
      </Mui.Grid>
      {openSidePeek ? (
        <EditCheckInOut
          setOpenSidePeek={setOpenSidePeek}
          openSidePeek={openSidePeek}
          shiftDetails={shiftDetails}
          setEditState={setEditState}
          departmentId={departmentId}
        />
      ) : null}
    </React.Fragment>
  );
};
